import { render, staticRenderFns } from "./NotifyItem.vue?vue&type=template&id=5d7472c2"
import script from "./NotifyItem.vue?vue&type=script&lang=js"
export * from "./NotifyItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports